{
  "nl": {
    "datatable": {
      "actions": {
        "bulk_action": "Actie in bulk",
        "bulk_edit": "Bewerk in bulk",
        "clear": "Wissen",
        "clear_filters": "Filters wissen",
        "collapse_all": "Alles inklappen",
        "deselect_all": "Alles deselecteren",
        "expand_all": "Alles uitklappen",
        "select_all": "Alles selecteren"
      },
      "import": {
        "error_row": "Rij {row}",
        "errors_description": "De import is geannuleerd omdat {count} rij(en) fouten bevatten. Er zijn geen records geïmporteerd.",
        "errors_title": "Import mislukt",
        "success": "Bestand succesvol geïmporteerd",
        "title": "Importeren"
      },
      "labels": {
        "columns_selected": "{count} kolommen geselecteerd",
        "freeze_columns": "Kolommen vastzetten",
        "freeze_rows": "Rijen vastzetten",
        "gridlines": "Rasterlijnen",
        "group_by": "Groeperen op",
        "size": "Grootte",
        "sticky_headers": "Vaste kopteksten",
        "striped_rows": "Gestreepte rijen",
        "toggle_columns": "Kolommen tonen/verbergen",
        "translation_mode_header": "Kolomkop",
        "translation_mode_stacked": "Gestapeld",
        "translation_mode_toolbar": "Globaal",
        "translation_style": "Vertaalstijl"
      }
    }
  }
}
